




<div  class="container">
  <div class="row">
    <div class="col-md-12">
      <!-- <ng-container *ngIf="aggs.inactive">
        <ng-container *ngIf="facetKeys != 'facet_stadt'">
          <ng-container *ngIf="aggs.inactive.length > 10">
            <div class="mehr">
              <mat-slide-toggle (change)="toggleAmount()">{{buttonName}}</mat-slide-toggle>
            </div>
          </ng-container>
        </ng-container>
      </ng-container> -->





<mat-expansion-panel
>
  <mat-expansion-panel-header>
    <mat-panel-title>

      <ng-container *ngIf="title == 'Kategorie'">
        <mat-icon class="mr-4 blue">manage_search</mat-icon>
      </ng-container>

      <ng-container *ngIf="title == 'Stadt'">
        <mat-icon class="mr-4 blue">location_city</mat-icon>
      </ng-container>

      <ng-container *ngIf="title == 'Wahl'">
        <mat-icon class="mr-4 blue">bar_chart</mat-icon>
      </ng-container>

      <ng-container *ngIf="title == 'Partei'">
        <mat-icon class="mr-4 blue">groups</mat-icon>
      </ng-container>

      <ng-container *ngIf="title == 'Geschlecht'">
        <mat-icon class="mr-4 blue">wc</mat-icon>
      </ng-container>

      {{ title }}
    </mat-panel-title>
    <mat-panel-description>
      <!-- This is a summary of the content -->
    </mat-panel-description>
  </mat-expansion-panel-header>
 

          <!-- <h3>ACTIVE</h3> -->
          <ul class="facets-list" *ngIf="aggs.active">
            <li *ngFor="let facet of aggs.active.slice(0,anzahl); let index = index">
              <ng-container *ngIf="facet.key.length != 0">
                  <mat-checkbox [disabled]="isLoadingResults"
                  (change)="onChange(facet.key, $event.checked)"
                  [checked]="selectedTerms.indexOf(facet.key) > -1"><p class="capi">{{facet.key}} <span style="font-size: 0.6rem;">({{ facet.doc_count }})</span></p> </mat-checkbox>
              </ng-container>
            </li>

        </ul>
         <!-- <h3>INACTIVE</h3> -->
        <ul class="facets-list" *ngIf="aggs.inactive">
            <li *ngFor="let facet of aggs.inactive.slice(0,anzahl); let index = index">
              <ng-container *ngIf="facet.key.length != 0">
                  <mat-checkbox [disabled]="isLoadingResults"
                  (change)="onChange(facet.key, $event.checked)"
                  [checked]="selectedTerms.indexOf(facet.key) > -1"><p class="capi">{{facet.key}} <span style="font-size: 0.6rem;">({{ facet.doc_count }})</span></p> </mat-checkbox>
              </ng-container>
            </li>
        </ul>


</mat-expansion-panel>

<!-- <div class="container">
  <h5 class="facet-title"></h5>
</div>

 
    </div>
  </div>
</div> -->

